import React from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";

const Layout = ({ children, title }) => {
  return (
    <div className="bg-dry min-h-screen flex">
      {/* Sidebar */}
      <div className="hidden md:block ">
        <Sidebar />
      </div>

      {/* Main Content */}
      <div className="flex-1 overflow-y-auto relative">
        <Header title={title} />
        <div className="xs:px-8 px-2 pt-4">{children}</div>
      </div>
    </div>
  );
};

export default Layout;
